import AddRoleForm from 'organization/Team/Roles/AddRoleForm'
import RolesTable from 'organization/Team/Roles/RolesTable'
import React from 'react'

export default function Roles() {
  return (
    <>
      <AddRoleForm />
      <RolesTable />
    </>
  )
}
